module.exports = __webpack_public_path__ + "img/1792485482325.cf6c79b8.png";